import { message } from 'utils/stringUtils';

export const creditCardErrorMessages = {
  cardNumberRequired: message('Validations:cardNumberRequired'),
  invalidCardNumber: message('Validations:invalidCardNumber'),
  holderNameRequired: message('Validations:holderNameRequired'),
  expiresRequired: message('Validations:expiresRequired'),
  invalidExpires: message('Validations:invalidExpires'),
  securityCodeRequired: message('Validations:securityCodeRequired')
};
